import apiFetch from '../apiFetch'

export default function (idOperario, token) {
  return apiFetch({endPoint: `Operario/getCambiarOperarioAlbaran`, method: 'POST', body: {idOperario}, token: token})
}